import React from 'react';
import {DurationPicker, DurationUnit} from "../Control";
import {useField} from "formik";
import FieldHelp from "./FieldHelp";
import {Duration} from "luxon";

// Component ----

type DurationFieldProps = {
  name: string
  id?: string
  label: string
  hint?: string
  help?: string
  units?: Array<DurationUnit>
}

function DurationField({help, hint, id, label, name, units}: DurationFieldProps) {
  const [field, meta, {setValue, setTouched}] = useField(name)

  function handleChange(duration: Duration) {
    setTouched(true)
    setValue(duration.as('seconds'))
  }

  // Error state
  const hasError = meta.touched && !!meta.error

  return (
    <div>
      <DurationPicker
        id={id || name}
        label={label}
        hint={hint}
        units={units}
        value={Duration.fromObject({seconds: Number(field.value)})}
        onChange={handleChange}
      />

      {/* Help text or error message */}
      {(!!help || hasError) &&
        <FieldHelp isError={hasError}>
          {hasError ? meta.error : help}
        </FieldHelp>
      }
    </div>

  );
}

export default DurationField;